"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagQuery = exports.TagUpdate = exports.TagCreate = exports.TagTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const meta_data_1 = require("../../common/meta-data");
const profile_1 = require("../../profile");
const enums_1 = require("./enums");
const tag_type_1 = require("./tag-type");
exports.TagTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    type: tag_type_1.TagTypeTransport,
    name: typebox_1.Type.String(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    backgroundColor: typebox_1.Type.Optional(typebox_1.Type.String({ pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$' })),
    textColor: typebox_1.Type.Optional(typebox_1.Type.String({ pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$' })),
    category: typebox_1.Type.Optional(enums_1.TagCategory),
    defaultAssignedTeam: typebox_1.Type.Optional(profile_1.SourgumTeam),
    //   showToCustomer: Type.Boolean(),
    deletedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: meta_data_1.MetaData,
});
exports.TagCreate = typebox_1.Type.Omit(exports.TagTransport, ['id', 'metadata', 'deletedAt', 'type']);
exports.TagUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.TagTransport, ['id', 'metadata', 'deletedAt', 'type']));
exports.TagQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        /**
         * (Sourgum only) Needs to be a comma separated list of tag categories. Use [].join(',')
         */
        category: typebox_1.Type.String({ minLength: 1 }),
        /**
         * (Sourgum only)Needs to be a comma separated list of type SourgumTeam. Use [].join(',')
         */
        defaultAssignedTeam: typebox_1.Type.String({ minLength: 1 }),
        /**
         * Pass up false if you only want non deleted notes
         */
        deletedAt: typebox_1.Type.Boolean(),
        //   showToCustomer: Type.Boolean(),
    }),
]));
//# sourceMappingURL=tag.js.map